module.exports = __webpack_public_path__ + "myMideaLink.a087d577.jpg";